export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGIN_FALIURE="LOGIN_FALIURE";

export const LOGOUT_REQUEST="LOGOUT_REQUEST";
export const LOGOUT_SUCESS="LOGOUT_SUCESS";
export const LOGOUT_FAILURE="LOGOUT_FAILURE"

export const REGISTER_REQUEST="REGISTER_REQUEST";
export const REGISTER_SUCCESS="REGISTER_SUCCESS";
export const REGISTER_FAILURE="REGISTER_FAILURE";
